import { makeStyles } from '@fluentui/react-components';

export const useSideNavStyles = makeStyles({
  sidebar: {
    width: '250px',
    backgroundColor: 'var(--colorNeutralBackground4)',
    borderRight: '1px solid var(--colorNeutralStroke2)',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    transitionProperty: 'width',
    transitionDuration: '200ms',
    transitionTimingFunction: 'ease',
    overflowX: 'hidden',
  },
  sidebarCollapsed: {
    width: '64px',
  },
  sidebarHeader: {
    marginBottom: '8px',
    paddingBottom: '4px',
  },
  navGroup: {
    marginBottom: '16px',
  },
  navGroupLabel: {
    display: 'block',
    padding: '4px 8px',
    marginBottom: '12px',
    color: 'var(--colorNeutralForeground3)',
    fontWeight: '600',
    letterSpacing: '0.5px',
  },
  navItem: {
    width: '100%',
    justifyContent: 'flex-start',
    marginTop: '8px',
    gap: '12px',
  },
  sidebarFooter: {
    marginTop: 'auto',
    paddingTop: '16px',
    borderTop: '1px solid var(--colorNeutralStroke2)',
  },
});
